import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Link, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import Box from "@mui/material/Box";
import CustomInput from "../../components/CustomInput";
import { ForgotPasswordValidate } from "../../helper/Validation";
import { useForm } from "../../hooks/useForm";
import { useAlert } from "../../context/AlertContext";
import { LoadingButton } from "@mui/lab";
import Carousel from "react-material-ui-carousel";
import styles from "./styles";

const ForgotPasswordPage = ({ handleForgotPassword, loading }) => {
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  useEffect(() => {
    const Token = localStorage.getItem("accessToken");
    if (Token) {
      navigate("/dashboard");
    }
  }, []);

  const forgotPasswordInitialData = {
    email: {
      value: "",
      error: "",
    },
  };

  const handleSubmit = async (data) => {
    handleForgotPassword(data);
  };

  const { state, handleChange, handleSubmit: formSubmit, handleFocus, disable } = useForm(
    forgotPasswordInitialData,
    ForgotPasswordValidate,
    handleSubmit,
  );

  const { email } = state;

  return (
    <Box sx={styles.main}>
      <Container sx={styles.root}>
        <Paper sx={styles.paper}>
          <Grid container sx={styles.gridContainer}>
            <Grid item xs={12} sm={12} md={6} sx={styles.gridItem}>
              <Box sx={styles.formContain}>
                <Typography variant="h4" sx={styles.mainheading}>
                  Forgot Password
                </Typography>
                <Box sx={styles.headingborder}></Box>

                <Typography sx={styles.descriptionText}>
                  <Typography sx={styles.descriptionText}>
                    {"Enter your registered email address and we'll send you a password reset link."}
                  </Typography>
                </Typography>

                <form onSubmit={formSubmit} autoComplete="off">
                  <Box>
                    <Typography sx={styles.inputText}>Email Address</Typography>
                    <CustomInput
                      name="email"
                      value={email?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={email?.error}
                    />
                  </Box>

                  <LoadingButton
                    loading={loading}
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={disable}
                    sx={styles.submit}
                  >
                    Send Reset Link
                  </LoadingButton>
                </form>

                <Box sx={styles.backToLoginContainer}>
                  <Link to="/" style={styles.backToLoginLink}>
                    <Typography sx={styles.backToLoginText}>
                      ← Back to Login
                    </Typography>
                  </Link>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Carousel indicators={false}>
                <Box sx={styles.image}>
                  <Box sx={styles.backgroundImage}></Box>
                  <Typography sx={styles.sliderText}>
                    Securely reset your password using a verification link sent to your registered email address. Keep your account protected with a safe and reliable recovery process.
                  </Typography>
                  <Box sx={styles.dots}>
                    <Box sx={styles.dot2}></Box>
                    <Box sx={styles.dot1}></Box>
                  </Box>
                </Box>
                <Box sx={styles.image}>
                  <Box sx={styles.backgroundImage2}></Box>
                  <Typography sx={styles.sliderText}>
                    Regain access to your account quickly and securely. Follow the password reset link in your email to create a new password and continue using your account safely.
                  </Typography>
                  <Box sx={styles.dots}>
                    <Box sx={styles.dot1}></Box>
                    <Box sx={styles.dot2}></Box>
                  </Box>
                </Box>
              </Carousel>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ForgotPasswordPage;
